import { Component, Input, OnInit, inject } from "@angular/core";
import { DocumentTemplatesDataService } from "@app/document-templates/document-templates-data.service";
import { MergeFieldTableModel } from "@app/document-templates/models/merge-field-table-model";
import { TargetModule } from "@enums/document/TargetModule";
import { firstValueFrom } from "rxjs";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { CerrixCollapsingBoxComponent } from "@app/shared/cerrix-collapsing-box/cerrix-collapsing-box.component";

@Component({
    selector: "document-templates-merge-fields",
    templateUrl: "./document-templates-merge-fields.component.html",
    styleUrls: ["./document-templates-merge-fields.component.scss"],
    imports: [TooltipModule, CerrixCollapsingBoxComponent]
})
export class DocumentTemplatesMergeFieldsComponent implements OnInit {
    private dataService = inject(DocumentTemplatesDataService);

    @Input() targetModule: TargetModule;

    protected mergeFieldTables: MergeFieldTableModel[];

    async ngOnInit() {
        this.mergeFieldTables = await firstValueFrom(
            this.dataService.getMergeFields(this.targetModule)
        );
    }

    protected copyField(mergeFieldName: string): void {
        navigator.clipboard.writeText(`MERGEFIELD ${mergeFieldName}`);
    }
}
